// --------------------------------------------------------------------------
// #TBC - UNSAVED FORM USER PROMPT
//      - If a user has changed any form fields and trys to navigates away
//        without submitting then they will be prompted to stay on the page.
//      - Uses native browser functionality so appearance/message is browser
//        specific.
// --------------------------------------------------------------------------
// Author:      Thomas Jeatt
// Email:       frontend@zonedigital.com
// URL:         http://zonedigital.com
// Copyright:   Copyright (c) 2016, zonedigital.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

module.exports = function (options) {

    var context = options.context;

    function init() {
        var form = context;
        var formFields = form.find('input');
        var formChanged = false;
        var formSaved = false;

        formFields.on('change', function () {
            formChanged = true;
        });

        form.on('submit', function () {
            formSaved = true;
        });

        window.onbeforeunload = function () {
            if (formChanged === true && formSaved === false) {

                return 'Do you want to reload this page? Changes that you made may not be saved.';
            }
        };
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/unsaved-form-prompt.js
// module id = 259
// module chunks = 0